import React from 'react';
import {I18nextProvider} from 'react-i18next';

import DropZone from './DropZone.jsx';
import defaultI18N from './i18n.js';

const I18nDropZone = props => (
  <I18nextProvider i18n={defaultI18N}>
    <DropZone {...props} />
  </I18nextProvider>
);

export default I18nDropZone;
